import PropTypes from 'prop-types'
import { ToolbarContainer } from '../styled-components.js'

const TableToolbarRoot = ({ children }) => {
  return <ToolbarContainer>{children}</ToolbarContainer>
}

TableToolbarRoot.propTypes = {
  children: PropTypes.node.isRequired
}

export default TableToolbarRoot
